import { render } from "./PpcBudgetAllocationWeeklyBudgetInput.vue?vue&type=template&id=8f056932&scoped=true"
import script from "./PpcBudgetAllocationWeeklyBudgetInput.vue?vue&type=script&lang=js"
export * from "./PpcBudgetAllocationWeeklyBudgetInput.vue?vue&type=script&lang=js"

import "./PpcBudgetAllocationWeeklyBudgetInput.vue?vue&type=style&index=0&id=8f056932&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8f056932"]])

export default __exports__